import hres33uLabels from 'assets/labels/hres33u'
import faker from 'faker'
import moment from 'moment'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hres33uLabels
    }
  },
  index () {
    let mockRows = []
    let staappr = ''
    let typ = ''
    const mockTyp = [ '1', '2', '3', '4', '5', '6' ]
    const mockDescTyp = {
      '1': '1ชื่อพนักงาน',
      '2': '2ข้อมูลส่วนตัว',
      '3': '3ข้อมูลการศึกษา',
      '4': '4ข้อมูลบุตร',
      '5': '5ข้อมูลคุณความดี',
      '6': '6ข้อมูลการฝึกอบรม'
    }
    const mockStaappr = [ 'P', 'Y', 'N', 'A', 'C' ]
    const mockStatus = {
      'P': 'รอพิจารณา',
      'Y': 'อนุมัติ',
      'N': 'ไม่อนุมัติ',
      'A': 'ระหว่างอนุมัติ',
      'C': 'ยกเลิก'
    }
    const mockTotal = 10
    for (var i = 1; i <= mockTotal; i++) {
      staappr = mockStaappr[Math.floor(Math.random() * 5)]
      typ = mockTyp[Math.floor(Math.random() * 6)]
      mockRows.push({
        id: i,
        staappr: '',
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        dtereq: moment().format('DD/MM/YYYY'),
        numseq: faker.random.number().toString().substr(0, 1),
        typ: typ,
        desc_typ: mockDescTyp[typ],
        status: mockStatus[staappr],
        desc_codappr: faker.name.findName(),
        dteappr: moment().format('DD/MM/YYYY'),
        remark: 'Test HRES33U',
        desc_codempap: faker.name.findName(),
        approvno: faker.random.number().toString().substr(0, 1),
        chk_appr: ''
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    let mockTab1 = {
      codinput: faker.lorem.word(),
      desc_codinput: faker.name.findName(),
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      dtereq: moment().format('DD/MM/YYYY'),
      title_o: faker.name.prefix(),
      name_ot: faker.name.firstName(),
      lastname_ot: faker.name.lastName(),
      name_oe: faker.name.firstName(),
      lastname_oe: faker.name.lastName(),
      title_n: faker.name.prefix(),
      name_nt: faker.name.firstName(),
      lastname_nt: faker.name.lastName(),
      name_ne: faker.name.firstName(),
      lastname_ne: faker.name.lastName(),
      desnote: 'Test HRES33U'
    }
    let mockTab2Detail1 = {
      codinput: faker.lorem.word(),
      desc_codinput: faker.name.findName(),
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      dtereq: moment().format('DD/MM/YYYY'),
      adrcont1: faker.address.streetAddress(),
      desc_codsubdistr: faker.address.streetSuffix(),
      desc_coddistr: faker.address.streetName(),
      desc_codprovr: faker.address.county(),
      desc_codcntyr: faker.address.country(),
      codpostr: faker.random.number(),
      adrcont2: faker.address.streetAddress(),
      desc_codsubdistc: faker.address.streetSuffix(),
      desc_coddistc: faker.address.streetName(),
      desc_codprovc: faker.address.county(),
      desc_codcntyc: faker.address.country(),
      codpostc: faker.random.number(),
      numtelec: faker.phone.phoneNumberFormat(),
      flg_adrcont1: faker.random.number(),
      flg_desc_codsubdistr: faker.random.number(),
      flg_desc_coddistr: faker.random.number(),
      flg_desc_codprovr: faker.random.number(),
      flg_desc_codcntyr: faker.random.number(),
      flg_codpostr: faker.random.number(),
      flg_adrcont2: faker.random.number(),
      flg_desc_codsubdistc: faker.random.number(),
      flg_desc_coddistc: faker.random.number(),
      flg_desc_codprovc: faker.random.number(),
      flg_desc_codcntyc: faker.random.number(),
      flg_codpostc: faker.random.number(),
      flg_numtelec: faker.random.number()
    }
    let mockTab2Detail2 = {
      codinput: faker.lorem.word(),
      desc_codinput: faker.name.findName(),
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      dtereq: moment().format('DD/MM/YYYY'),
      numoffid: faker.random.number(),
      adrissue: faker.random.number(),
      desc_codprovi: faker.address.county(),
      dteoffid: moment().format('DD/MM/YYYY'),
      numpasid: faker.random.number(),
      dtepasid: moment().format('DD/MM/YYYY'),
      numprmid: faker.random.number(),
      dteprmst: moment().format('DD/MM/YYYY'),
      dteprmen: moment().format('DD/MM/YYYY'),
      numlicid: faker.random.number(),
      dtelicid: moment().format('DD/MM/YYYY'),
      desc_stamarry: 'Single',
      desc_stamilit: 'Completed',
      flg_numoffid: faker.random.number(),
      flg_adrissue: faker.random.number(),
      flg_desc_codprovi: faker.random.number(),
      flg_dteoffid: faker.random.number(),
      flg_numlicid: faker.random.number(),
      flg_dtelicid: faker.random.number(),
      flg_numpasid: faker.random.number(),
      flg_dtepasid: faker.random.number(),
      flg_numprmid: faker.random.number(),
      flg_dteprmst: faker.random.number(),
      flg_dteprmen: faker.random.number(),
      flg_desc_stamarry: faker.random.number(),
      flg_desc_stamilit: faker.random.number()
    }
    let mockTab2Detail3 = {
      codinput: faker.lorem.word(),
      desc_codinput: faker.name.findName(),
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      dtereq: moment().format('DD/MM/YYYY'),
      namfathr: faker.name.findName(),
      desc_codfnatn: 'Austrian',
      desc_codfrelg: 'Buddhism',
      desc_codfoccu: faker.name.jobTitle(),
      numofidf: faker.random.number(),
      nammothr: faker.name.findName(),
      desc_codmnatn: 'German',
      desc_codmrelg: 'Catholic',
      desc_codmoccu: faker.name.jobTitle(),
      numofidm: faker.random.number(),
      namcont: faker.name.findName(),
      adrcont1: faker.address.streetAddress(),
      codpost: faker.random.number(),
      numtele: faker.phone.phoneNumberFormat(),
      numfax: faker.phone.phoneNumberFormat(),
      email: faker.internet.email(),
      desrelat: 'mother',
      flg_namfathr: faker.random.number(),
      flg_desc_codfnatn: faker.random.number(),
      flg_desc_codfrelg: faker.random.number(),
      flg_desc_codfoccu: faker.random.number(),
      flg_numofidf: faker.random.number(),
      flg_nammothr: faker.random.number(),
      flg_desc_codmnatn: faker.random.number(),
      flg_desc_codmrelg: faker.random.number(),
      flg_desc_codmoccu: faker.random.number(),
      flg_numofidm: faker.random.number(),
      flg_namcont: faker.random.number(),
      flg_adrcont1: faker.random.number(),
      flg_codpost: faker.random.number(),
      flg_numtele: faker.random.number(),
      flg_numfax: faker.random.number(),
      flg_email: faker.random.number(),
      flg_desrelat: faker.random.number()
    }
    let mockTab2Detail4 = {
      codinput: faker.lorem.word(),
      desc_codinput: faker.name.findName(),
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      dtereq: moment().format('DD/MM/YYYY'),
      namspous: faker.name.findName(),
      numoffid: faker.random.number(),
      dtespbd: moment().format('DD/MM/YYYY'),
      desc_codspocc: faker.name.jobType(),
      desnoffi: faker.address.streetAddress(),
      dtemarry: moment().format('DD/MM/YYYY'),
      desplreg: faker.address.streetAddress(),
      desc_codsppro: faker.address.county(),
      desc_codspcty: faker.address.country(),
      desnote: 'Test HRES33U',
      flg_namspous: faker.random.number(),
      flg_numoffid: faker.random.number(),
      flg_dtespbd: faker.random.number(),
      flg_desc_codspocc: faker.random.number(),
      flg_desnoffi: faker.random.number(),
      flg_dtemarry: faker.random.number(),
      flg_desplreg: faker.random.number(),
      flg_desc_codsppro: faker.random.number(),
      flg_desc_codspcty: faker.random.number(),
      flg_desnote: faker.random.number()
    }
    let mockTab2Detail5 = {
      codinput: faker.lorem.word(),
      desc_codinput: faker.name.findName(),
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      dtereq: moment().format('DD/MM/YYYY'),
      desc_codbank: 'Codbank',
      numbank: faker.random.number(),
      amtbank: faker.finance.amount(),
      desc_codbank2: 'Codbank',
      numbank2: faker.random.number(),
      flg_desc_codbank: faker.random.number(),
      flg_numbank: faker.random.number(),
      flg_amtbank: faker.random.number(),
      flg_desc_codbank2: faker.random.number(),
      flg_numbank2: faker.random.number()
    }
    let mockTab2Detail6 = {
      codinput: faker.lorem.word(),
      desc_codinput: faker.name.findName(),
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      dtereq: moment().format('DD/MM/YYYY'),
      qtychedu: faker.random.number().toString().substr(0, 1),
      qtychned: faker.random.number().toString().substr(0, 1),
      flg_qtychedu: faker.random.number(),
      flg_qtychned: faker.random.number()
    }
    let mockTab2Detail6Rows = []
    const mockTab2Detail6Total = 5
    for (var a = 1; a <= mockTab2Detail6Total; a++) {
      mockTab2Detail6Rows.push({
        id: a,
        coddeduct: faker.lorem.word(),
        desc_coddeduct: 'Test HRES33U',
        amtdeduct: faker.random.number()
      })
    }
    let mockTab2Detail7 = {
      codinput: faker.lorem.word(),
      desc_codinput: faker.name.findName(),
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      dtereq: moment().format('DD/MM/YYYY')
    }
    let mockTab2Detail7Rows = []
    const mockTab2Detail7Total = 5
    for (var b = 1; b <= mockTab2Detail7Total; b++) {
      mockTab2Detail7Rows.push({
        id: b,
        numseq: faker.random.number(),
        desc_codtydoc: 'transript',
        namdoc: faker.system.fileName(),
        numdoc: faker.finance.account(),
        filename: faker.system.commonFileName(),
        path_filename: faker.system.mimeType(),
        dterecv: moment().format('DD/MM/YYYY'),
        dtedocen: moment().format('DD/MM/YYYY'),
        desnote: 'Test HRES33U'
      })
    }
    let mockTab3Detail = {
      codinput: faker.lorem.word(),
      desc_codinput: faker.name.findName(),
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      dtereq: moment().format('DD/MM/YYYY')
    }
    let mockTab3Detail1Rows = []
    const mockTab3Detail1Total = 2
    for (var e = 1; e <= mockTab3Detail1Total; e++) {
      mockTab3Detail1Rows.push({
        id: e,
        numseq: faker.random.number().toString().substr(0, 1),
        level_n: 'Bachelor',
        degree_n: 'Bachelor of Science (B. Sc.)',
        major_n: 'Science',
        subject_n: 'Computer Science',
        inst_n: 'King Mongkut"s University of Technology Thonburi ',
        country_n: faker.address.country(),
        numgpa_n: faker.random.number().toString().substr(0, 1) + '.' + faker.random.number().toString().substr(0, 2),
        stayear_n: moment().format('YYYY'),
        dtegyear_n: moment().format('YYYY'),
        flgeduc_n: 'Main'
      })
    }
    let mockTab3Detail2Rows = []
    const mockTab3Detail2Total = 2
    for (var f = 1; f <= mockTab3Detail2Total; f++) {
      mockTab3Detail2Rows.push({
        id: f,
        numseq: faker.random.number().toString().substr(0, 1),
        level_o: 'Bachelor',
        degree_o: 'Bachelor of Science (B. Sc.)',
        major_o: 'Science',
        subject_o: 'Computer Science',
        inst_o: 'King Mongkut"s University of Technology Thonburi ',
        country_o: faker.address.county(),
        numgpa_o: faker.random.number().toString().substr(0, 1) + '.' + faker.random.number().toString().substr(0, 2),
        stayear_o: moment().format('YYYY'),
        dtegyear_o: moment().format('YYYY'),
        flgeduc_o: 'Main'
      })
    }
    let mockTab4Detail = {
      codinput: faker.lorem.word(),
      desc_codinput: faker.name.findName(),
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      dtereq: moment().format('DD/MM/YYYY')
    }
    let mockTab4Detail1Rows = []
    let sex = ''
    const mockSex = [ 'M', 'F' ]
    const mockStatus = {
      'M': 'Male',
      'F': 'Female'
    }
    const mockTab4Detail1Total = 2
    for (var c = 1; c <= mockTab4Detail1Total; c++) {
      sex = mockSex[Math.floor(Math.random() * 2)]
      mockTab4Detail1Rows.push({
        id: c,
        flgchange: '',
        numseq: faker.random.number().toString().substr(0, 1),
        namchild: faker.name.findName(),
        dtechbd: moment().format('DD/MM/YYYY'),
        desc_codsex: mockStatus[sex],
        desc_codeduc: 'B.A. (Bachelor of Arts)'
      })
    }
    let mockTab4Detail2Rows = []
    const mockTab4Detail2Total = 2
    for (var d = 1; d <= mockTab4Detail2Total; d++) {
      sex = mockSex[Math.floor(Math.random() * 2)]
      mockTab4Detail2Rows.push({
        id: d,
        numseq: faker.random.number().toString().substr(0, 1),
        namchild: faker.name.findName(),
        dtechbd: moment().format('DD/MM/YYYY'),
        desc_codsex: mockStatus[sex],
        desc_codeduc: 'B.A. (Bachelor of Arts)'
      })
    }
    let mockTab5 = {
      codinput: faker.lorem.word(),
      desc_codinput: faker.name.findName(),
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      dtereq: moment().format('DD/MM/YYYY'),
      desc_codrewd: 'Outstanding Employee Award',
      desrewd1: 'test-description ',
      numhmref: faker.finance.bitcoinAddress()
    }
    let mockTab6Detail = {
      codinput: faker.lorem.word(),
      desc_codinput: faker.name.findName(),
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      dtereq: moment().format('DD/MM/YYYY')
    }
    let mockTab6Detail1Rows = []
    const mockTab6Detail1Total = 5
    for (var g = 1; g <= mockTab6Detail1Total; g++) {
      mockTab6Detail1Rows.push({
        id: g,
        numseq: faker.random.number().toString().substr(0, 1),
        destrain_n: faker.name.jobType(),
        dtetrain_n: moment().format('DD/MM/YYYY'),
        dtetren_n: moment().format('DD/MM/YYYY'),
        displace_n: faker.address.country(),
        desinstu_n: 'บริษัท ABC จำกัด มหาชน'
      })
    }
    let mockTab6Detail2Rows = []
    const mockTab6Detail2Total = 5
    for (var h = 1; h <= mockTab6Detail2Total; h++) {
      mockTab6Detail2Rows.push({
        id: h,
        numseq: faker.random.number().toString().substr(0, 1),
        destrain_o: faker.name.jobType(),
        dtetrain_o: moment().format('DD/MM/YYYY'),
        dtetren_o: moment().format('DD/MM/YYYY'),
        displace_o: faker.address.country(),
        desinstu_o: 'บริษัท ABC จำกัด มหาชน'
      })
    }

    return {
      tab1: mockTab1,
      tab2: {
        tab1: mockTab2Detail1,
        tab2: mockTab2Detail2,
        tab3: mockTab2Detail3,
        tab4: mockTab2Detail4,
        tab5: mockTab2Detail5,
        tab6: {
          detail: mockTab2Detail6,
          table: {
            total: mockTab2Detail6Total,
            rows: mockTab2Detail6Rows
          }
        },
        tab7: {
          detail: mockTab2Detail7,
          table: {
            total: mockTab2Detail7Total,
            rows: mockTab2Detail7Rows
          }
        }
      },
      tab3: {
        detail: mockTab3Detail,
        table1: {
          total: mockTab3Detail1Total,
          rows: mockTab3Detail1Rows
        },
        table2: {
          total: mockTab3Detail2Total,
          rows: mockTab3Detail2Rows
        }
      },
      tab4: {
        detail: mockTab4Detail,
        table1: {
          total: mockTab4Detail1Total,
          rows: mockTab4Detail1Rows
        },
        table2: {
          total: mockTab4Detail2Total,
          rows: mockTab4Detail2Rows
        }
      },
      tab5: mockTab5,
      tab6: {
        detail: mockTab6Detail,
        table1: {
          total: mockTab6Detail1Total,
          rows: mockTab6Detail1Rows
        },
        table2: {
          total: mockTab6Detail2Total,
          rows: mockTab6Detail2Rows
        }
      }
    }
  },
  // dropdowns () {
  //   let mockNumseqEn = {}
  //   let mockNumseqTh = {}
  //   const mockTotal = Math.floor(Math.random() * 5) + 5
  //   for (var i = 1; i <= mockTotal; i++) {
  //     mockNumseqEn[faker.lorem.word()] = faker.random.number().toString().substr(0, 1)
  //     mockNumseqTh[faker.lorem.word()] = faker.random.number().toString().substr(0, 1)
  //   }
  //   return {
  //     numseq: {
  //       en: mockNumseqEn,
  //       th: mockNumseqTh
  //     }
  //   }
  // },
  sendApprove () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hres33u/mocker.js